// extracted by mini-css-extract-plugin
export default {"label":"InfoFieldValue_label__J9NDn","value":"InfoFieldValue_value__wFVif","truncatedWrap":"InfoFieldValue_truncatedWrap__sQU3Z"};